import { render, staticRenderFns } from "./SocialPostImageDraggable.vue?vue&type=template&id=ff181f72&"
import script from "./SocialPostImageDraggable.vue?vue&type=script&lang=js&"
export * from "./SocialPostImageDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports